import { Badge, BadgeProps, Flex } from '@mantine/core';
import Text from 'mantine-components/widget/text';
import React from 'react';
import { UniskaiButtonType } from 'templates/actions/utils';

import UniskaiFormHeaderActions, {
  UniskaiFormHeaderActionProps,
} from './uniskai-form-header-action';

export interface UniskaiFormHeaderProps<T = any>
  extends UniskaiFormHeaderActionProps<T> {
  title?: string;
  badgeProps?: BadgeProps;
  badge?: React.ReactNode;

  type?: 'default' | 'default-footer' | 'custom';
}
export type UniskaiFormHeaderRef = {
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
};

const UniskaiFormHeader = React.forwardRef<
  UniskaiFormHeaderRef,
  UniskaiFormHeaderProps
>((props, ref) => {
  const { type = 'default', badgeProps, badge, ...rest } = props;
  const [title, setTitle] = React.useState(props.title || '');

  React.useImperativeHandle(ref, () => {
    return {
      title,
      setTitle,
    };
  });

  const headerActions = React.useMemo(() => {
    const customs = props.customs || [];
    let actions = ['save', 'cancel', 'edit'] as UniskaiButtonType[];
    if (type === 'default-footer') {
      actions = ['edit'];
    }
    // remove duplicates
    actions.forEach((type) => {
      const custom = customs.find((custom) => custom.type === type);
      if (!custom) {
        customs.push({
          type,
        });
      }
    });
    return <UniskaiFormHeaderActions {...rest} customs={customs} />;
  }, [props.customs, rest, type]);

  return (
    <Flex wrap="wrap" align="start" gap={16}>
      <Flex
        flex={1}
        style={{ flexShrink: 0 }}
        align={{
          base: 'start',
          md: 'center',
        }}
        gap={{
          base: 8,
          md: 16,
        }}
        direction={{
          base: 'column',
          md: 'row',
        }}
      >
        <Text variant="h5Medium">{title}</Text>
        {badge}
        {badgeProps && <Badge {...badgeProps} />}
      </Flex>
      <Flex gap={8} wrap="wrap">
        {headerActions}
      </Flex>
    </Flex>
  );
});

UniskaiFormHeader.displayName = 'UniskaiFormHeader';

export default UniskaiFormHeader;
